module.exports = {
  "nav.BRAND": "Apollon Advies",
  "nav.NEW": "Nieuw",
  "nav.IMPORT": "Importeren",
  "nav.CASES": "Cases",
  "nav.ANALYSE": "Analyse",
  "nav.EXPORT": "Exporteren",
  "nav.BATCH": "Batch",
  "nav.ACTION": "Acties",
  "nav.ADMIN": "Beheer",
  "nav.LOGOUT": "Uitloggen",
  "nav.CUSTOMER": "Klanten",
  "nav.CLOSE_CASES": "Cases sluiten",
  "nav.INSURER_MANAGEMENT": "Branches en risicodragers",
  "nav.USER_MANAGEMENT": "Gebruikers",
  "nav.CONFIGURATION_MANAGEMENT": "Scherminrichting",
  "nav.TRANSFORMATION_FILES": "Transformatie bestanden",
  "nav.BUSINESS_RULES": "Definieer Business Rules",
  "nav.BASE_TABLES": "Stamtabellen",
  "nav.PDF_TEMPLATES": "PDF sjabloon",
  "nav.PDF_TEMPLATES_FILES": "PDF sjabloonbestanden",
  "ACCEPT_MANUALLY": "Handmatig accepteren",
  "RECALCULATE_TITLE": "Herberekenen voor accepteren",
  "RECALCULATE_MESSAGE": "Omdat er gegevens gewijzigd zijn, dient de polis eerst herberekend te worden voordat deze kan worden geaccepteerd.",
  "ACCEPT_MANUALLY_MESSAGE": "Geef de reden aan waarom deze polis handmatig wordt geaccepteerd",
  "NoClaimsDiscountTable": "BM tabel",
  "COVER": "Dekking",
  "COVERS": "Dekkingen",
  "CALCULATE": "Berekenen",
  "RECALCULATE": "Herberekenen",
  "REOPEN": "Wijzigen",
  "NOT_AUTHORIZED_TO_EDIT": "U heeft geen toestemming om deze case aan te passen.",
  "RESPONSES": "Resultaat",
  "REQUEST_SUMMARY": "Aanvraag",
  "SELECT": "Selecteer",
  "SELECTED": "Geselecteerd",
  "SELECTED_POLICY": "Geselecteerde polis",
  "ACCEPT": "Accepteren",
  "CONFIRM_CLOSE_MESSAGE": "Weet u zeker dat deze polis geroyeerd moet worden?",
  "NOT_FOUND": "Niet gevonden",
  "CUSTOMER": "Klant",
  "UNIQUE_ID": "Unieke ID",
  "LAST_EDIT_USER": "Laatst gewijzigd",
  "LAST_EDIT_TIME": "Laatste wijziging",
  "PREVIEW": "Voorbeeld",
  "HIDE_PREVIEW": "Einde voorbeeld",
  "SHOW_ONLY_PREMIUMS": "Alleen premies tonen",
  "SHOW_FULL_INFO": "Volledig tonen",
  "SHOW_ALL": "Alles tonen",
  "MODIFY_SELECTED": "Selectie wijzigingen",
  "CANCEL_SELECTION": "Einde selectie",
  "No_Claims_Discount": "BM tabel",
  "SAVE_AND_ACCEPT": "Opslaan en accepteren",
  "msg.FORM_NOT_RENDERED_YET": "We kunnen het formulier niet verzenden omdat het nog niet volledig geladen is.",
  "msg.LIST_CASES_EMPTY": "Geen cases gevonden.",
  "No_Of_Policies": "Aantal polissen",
  "Package_Discounts": "Pakketkorting",
  "Description": "Omschrijving",
  "ADD_NEW_STEP": "Trede toevoegen",
  "ADD_NEW_LINE": "Regel toevoegen",
  "CoverType": "Dekkingstype",
  "Category": "Categorie",
  "API_VALUE_INCOMING": "API value(inkomend)",
  "API_VALUE_OUTGOING": "API value(uitgaand)",
  "department": "Afdeling",
  "ID": "ID",
  "POLICY_ID": "Polis #",
  "RELATION_ID": "Relatie #",
  "RELATION": "Relatie",
  "CURRENT": "Huidig",
  "TOP_2": "Beste 2",
  "SEARCH": "Zoek",
  "SEARCH_CASES": "ID, Polis # of Relatie #",
  "CASES": "\"Item's\"",
  "DATE": "Datum",
  "NEXT_PAGE": "Volgende",
  "PREV_PAGE": "Vorige",
  "CLOSE_CASE": "Royement",
  "CLOSE_CASE2": "Royeren",
  "SUMMARY": "Overzicht",
  "TO_TOP": "Naar top",
  "ALL_BATCHES": "Alle batch namen",
  "ALL_PRODUCT_LINES": "Alle branches",
  "ALL_POLICY_CASE_STATUSES": "Alle case statussen",
  "STATUS": "Status",
  "NET": "Netto",
  "DAYS": "dagen",
  "VALIDATIONS": "Validatie",
  "REASON": "Reden",
  "NET_PREMIUM": "Netto",
  "REQUESTED_SUMMARY_LABEL": "Huidige Premie",
  "RESPONSE_SUMMARIES_LABEL": "Nieuwe Premies",
  "EQUAL": "Gelijk",
  "NOT_AVAILABLE": "n.v.t.",
  "SHOW_VALIDATIONS": "Validatie tonen",
  "LOCK_CASE": "Niet op slot",
  "UNLOCK_CASE": "Op slot",
  "closeReason.REASON_1": "Bestaande polis voortzetten",
  "closeReason.REASON_2": "Royement bestaande polis, klant wenst geen nieuwe polis",
  "closeReason.REASON_3": "Royement bestaande polis, klant sluit nieuwe polis en maakt geen gebruik van voorstel",
  "closeReason.REASON_4": "Royement bestaande polis, handmatig overvoeren",
  "settings.TITLE": "Paston Apollon Advies - Applicatie en Versie informatie",
  "settings.SUMMARY": "Dit is de Apollon Advies Applicatie van Paston Solutions B.V. Deze applicatie is speciaal gemaakt voor verzekeringstussenpersonen. Met deze applicatie kunt u uw relatie, polis en schade-administratie beheren en gebruik maken van cases en taken om uw huidige polissen te vergelijken en de juiste aanbieding aan uw klanten te doen.",
  "settings.VERSION_SUMMARY": "De Paston Apollon Advies Applicatie is op maat configureerbaar en bestaat uit meerdere componenten met elk een eigen versienummer:",
  "settings.VERSION_TABLE_CAPTION": "Versie informatie",
  "settings.VERSION_TABLE_HEADER_MODULE": "Module",
  "settings.VERSION_TABLE_HEADER_VERSION": "Versie",
  "settings.DEFAULT_PAGE": "Standaard startscherm",
  "settings.SALES_CHANNELS": "Verkoopkanalen",
  "version.LABEL_WEB": "Gebruikersinterface",
  "version.LABEL_MODEL": "Datamodel",
  "version.LABEL_RULES": "Business Rules",
  "version.LABEL_CASES": "Case module",
  "version.LABEL_ADMIN": "Admin module",
  "version.LABEL_CHARTS": "Rapportage model",
  "msg.ERROR_GETTING_VERSIONS": "Er is een fout opgetreden bij het ophalen van een deel van de versie-informatie.",
  "status.OPEN": "Open",
  "status.NOT_ADVISED": "Uitval",
  "status.ADVISED": "Geadviseerd",
  "status.ACCEPTED": "Geaccepteerd",
  "status.ACCEPTED_MANUALLY": "Handmatig geaccepteerd",
  "status.ARCHIVED": "Geaccepteerd",
  "status.CLOSED": "Beëindigd",
  "status.HISTORICAL": "Historie",
  "status.REOPENED": "Heropend",
  "status.NOT_CALCULATED": "Niet berekend",
  "action.IMPORT": "Importeren",
  "action.IMPORT_CUSTOMERS": "Importeren klanten",
  "action.IMPORT_POLICIES": "Importeren polissen",
  "action.IMPORT_COVERS": "Importeren dekkingen",
  "action.EXPORT": "Exporteren",
  "action.RECALC": "Herberekenen",
  "action.RECALC_CASE_IDS": "Herberekenen",
  "action.CLOSE": "Sluiten",
  "action.CLOSE_CASE_IDS": "Sluiten",
  "action.DELETE": "Verwijderen",
  "action.DELETE_CUSTOMERS": "Verwijderen",
  "action.DELETE_CASES": "Verwijderen",
  "action.DELETE_CASE_IDS": "Verwijderen",
  "action.IMPORT_NVGA2": "Import NVGA 2.0",
  "product.LIABILITY": "AVP",
  "product.HOUSECONTENT": "Inboedel",
  "product.HOUSEFIRE": "Opstal",
  "product.HOUSECOMBI": "Opstal & Inboedel",
  "product.PASSENGERCAR": "Auto",
  "product.TRAVEL": "Doorlopende reis",
  "product.LIABILITY_JSON": "AVP - JSON",
  "product.HOUSECONTENT_JSON": "Inboedel - JSON",
  "product.HOUSEFIRE_JSON": "Opstal - JSON",
  "product.HOUSECOMBI_JSON": "Opstal & Inboedel - JSON",
  "product.PASSENGERCAR_JSON": "Auto - JSON",
  "product.TRAVEL_JSON": "Doorlopende reis - JSON",
  "product.LIABILITY_NEW": "AVP - Nieuw",
  "product.HOUSECONTENT_NEW": "Inboedel - Nieuw",
  "product.HOUSEFIRE_NEW": "Opstal - Nieuw",
  "product.HOUSECOMBI_NEW": "Opstal & Inboedel - Nieuw",
  "product.PASSENGERCAR_NEW": "Auto - Nieuw",
  "product.TRAVEL_NEW": "Doorlopende reis - Nieuw",
  "insurer.UNKNOWN": "-",
  "insurer.AEGON": "Aegon",
  "insurer.AIG": "Onbekend",
  "insurer.ALLIANZ": "Allianz",
  "insurer.AMLIN": "AMLIN",
  "insurer.AON_TOPGEAR": "Aon ADPL a.s.r.",
  "insurer.ARAG": "Arag",
  "insurer.ASR": "a.s.r.",
  "insurer.ATOSI": "Onbekend",
  "insurer.AVERO": "AvÃ©ro",
  "insurer.BOUWNED": "Onbekend",
  "insurer.BOVEMIJ": "Bovemij",
  "insurer.CEL": "Onbekend",
  "insurer.DAS": "DAS",
  "insurer.DL": "Delta Lloyd",
  "insurer.ESSENT": "Onbekend",
  "insurer.EUROPEESCHE": "Onbekend",
  "insurer.GENERALI": "Generali",
  "insurer.GOUDSE": "De Goudse",
  "insurer.HDI": "Onbekend",
  "insurer.HIENFELD": "W.A. Hienfeld",
  "insurer.HISCOX": "Hiscox",
  "insurer.INTERPOLIS": "Interpolis Schade",
  "insurer.KLAVERBLAD": "Klaverblad",
  "insurer.KAMPEN": "Van Kampen",
  "insurer.KUIPER": "Kuiper Assuradeuren",
  "insurer.LIPPMANN": "Onbekend",
  "insurer.LONDON": "London",
  "insurer.MEEUS": "Onbekend",
  "insurer.MIDGLAS": "Midglas",
  "insurer.NEDASCO": "Nedasco",
  "insurer.NN": "Nationale Nederlanden",
  "insurer.NOORDELINGE": "Noorderlinge",
  "insurer.NOORDHOLLANDSCHE": "Noordhollandsche van 1816",
  "insurer.OTHER": "Onbekend",
  "insurer.PROVIDE": "Provide",
  "insurer.REAAL": "Reaal",
  "insurer.RISK": "Risk Assuradeuren",
  "insurer.SAMENWERKING": "Samenwerking Glasverzekering",
  "insurer.TURIEN": "Turien & Co",
  "insurer.UMG": "UMG",
  "insurer.UNIGARANT": "Unigarant",
  "insurer.UVM": "Onbekend",
  "insurer.VEREENDE": "De Vereende",
  "insurer.VOOGD": "Voogd & Voogd",
  "insurer.VSP": "Vandien Service Provider",
  "insurer.VSS": "VVS Verzekeringen",
  "insurer.Wederkerige": "Wederkerige",
  "insurer.ZEEUWSE": "De Zeeuwse",
  "insurer.RHION": "Rhion",
  "insurer.DDU_NN": "Aon DDU NN (A2)",
  "insurer.IAK": "IAK Privé Pakket",
  "insurer.AON_ASR": "Aon DDU a.s.r. (A1)",
  "insurer.AON_DIRECT": "Aon Direct",
  "insurer.AON_WSM_ASR": "AON WSM a.s.r.",
  "insurer.AON_WSM_NN": "AON WSM Nationale Nederlanden",
  "insurer.NN_DDU": "AON DDU Nationale Nederlanden",
  "productLine.SUFFIX_DEFAULT": " - Cases",
  "productLine.SUFFIX_NEW": " - Nieuw",
  "term.MONTH": "maand",
  "term.QUARTER": "kwartaal",
  "term.HALF_YEAR": "halfjaar",
  "term.YEAR": "jaar",
  "term.1": "maand",
  "term.3": "kwartaal",
  "term.6": "halfjaar",
  "term.12": "jaar",
  "term.short.1": "m",
  "term.short.3": "kw",
  "term.short.6": "hj",
  "term.short.12": "j",
  "term.short.MONTH": "m",
  "term.short.QUARTER": "kw",
  "term.short.HALF_YEAR": "hj",
  "term.short.YEAR": "j",
  "cover.LIABILITY_MAIN": "Aansprakelijkheid",
  "cover.LIABILITY_STAR": "Ster dekking",
  "cover.LIABILITY_HUNTER": "Jagersrisico",
  "cover.LIABILITY_DIY": "Klusrisico",
  "cover.LIABILITY_VESSEL": "Boten",
  "cover.LIABILITY_REDRESS": "Verhaalservice",
  "cover.LIABILITY_RENTAL_UNITS": "Verhuurde wooneenheden",
  "cover.LIABILITY_LARGE_ANIMALS": "Grote dieren",
  "cover.short.LIABILITY_MAIN": "AVP",
  "cover.short.LIABILITY_STAR": "Ster",
  "cover.short.LIABILITY_HUNTER": "Jacht",
  "cover.short.LIABILITY_DIY": "Klus",
  "cover.short.LIABILITY_VESSEL": "Boten",
  "cover.short.LIABILITY_REDRESS": "Verhaal",
  "cover.short.LIABILITY_RENTAL_UNITS": "Verhuur",
  "cover.short.LIABILITY_LARGE_ANIMALS": "G. dieren",
  "ownrisk.LIABILITY_GENERIC": "ER standaard",
  "ownrisk.LIABILITY_CHILDREN": "ER kinderen",
  "ownrisk.LIABILITY_ADDITIONAL": "ER additioneel",
  "insuredamount.LIABILITY_GENERIC": "VS Algemeen",
  "insuredamount.LIABILITY_CHILDREN": "VS kinderen",
  "cover.PASSENGERCAR_LIABILITY": "Wettelijke aansprakelijkheid",
  "cover.PASSENGERCAR_LIMITED": "Beperkt casco",
  "cover.PASSENGERCAR_COMPREHENSIVE": "Volledig Casco",
  "cover.PASSENGERCAR_ROADSIDE_ASSISTANCE": "Pechhulp",
  "cover.PASSENGERCAR_PASSENGER_DAMAGE": "Schadeverzekering inzittenden",
  "cover.PASSENGERCAR_LEGAL_ASSISTANCE": "Rechtsbijstand motorrijtuigen",
  "cover.PASSENGERCAR_REDRESS": "Verhaalsbijstand",
  "cover.PASSENGERCAR_ACCESSORIES": "Accessoire dekking",
  "cover.PASSENGERCAR_AUDIO_EQUIPMENT": "Audio",
  "cover.PASSENGERCAR_PASSENGER_ACCIDENT": "Ongevallen inzittenden",
  "cover.PASSENGERCAR_BM_PROTECTION": "Bonus/Malus bescherming",
  "cover.PASSENGERCAR_B_M_PROTECTION": "Bonus/Malus bescherming",
  "cover.PASSENGERCAR_FREE_BODY_SHOP": "Vrijekeuze herstelbedrijf",
  "cover.PASSENGERCAR_TRAILER": "Aanhangwagendekking",
  "cover.short.PASSENGERCAR_LIABILITY": "WA",
  "cover.short.PASSENGERCAR_LIMITED": "BC",
  "cover.short.PASSENGERCAR_COMPREHENSIVE": "VC",
  "cover.short.PASSENGERCAR_ROADSIDE_ASSISTANCE": "Pechhulp",
  "cover.short.PASSENGERCAR_PASSENGER_DAMAGE": "SVI",
  "cover.short.PASSENGERCAR_LEGAL_ASSISTANCE": "RB",
  "cover.short.PASSENGERCAR_REDRESS": "Verhaal",
  "cover.short.PASSENGERCAR_ACCESSORIES": "Accsrs",
  "cover.short.PASSENGERCAR_AUDIO_EQUIPMENT": "Audio",
  "cover.short.PASSENGERCAR_PASSENGER_ACCIDENT": "OVI",
  "cover.short.PASSENGERCAR_BM_PROTECTION": "BM Besch",
  "cover.short.PASSENGERCAR_B_M_PROTECTION": "BM Besch",
  "cover.short.PASSENGERCAR_FREE_BODY_SHOP": "Vrij herst",
  "cover.short.PASSENGERCAR_TRAILER": "Aanhangw",
  "ownrisk.PASSENGERCAR_GENERIC": "ER standaard",
  "ownrisk.PASSENGERCAR_ADDITIONAL": "ER vrijwillig",
  "ownrisk.PASSENGERCAR_FREE_BODY_SHOP": "ER vrije keuze herstelbedrijf",
  "ownrisk.PASSENGERCAR_THEFT": "ER diefstal",
  "ownrisk.PASSENGERCAR_CASCO": "ER casco",
  "insuredamount.PASSENGERCAR_PASSENGER_ACCIDENT_DEATH": "VS ongevallen inzittenden / overlijden",
  "insuredamount.PASSENGERCAR_PASSENGER_ACCIDENT_DISABLED": "VS ongevallen inzittenden / invaliditeit",
  "insuredamount.PASSENGERCAR_AUDIO_EQUIPMENT": "VS audio",
  "insuredamount.PASSENGERCAR_ACCESSORIES": "VS accesoires",
  "insuredamount.PASSENGERCAR_PASSENGER_DAMAGE": "VS schadeverzekering inzittenden",
  "cover.HOUSECONTENT_BASIC": "UGV+ (Inboedel)",
  "cover.HOUSECONTENT_TOP": "AVBKO (Inboedel)",
  "cover.HOUSECONTENT_GLASS": "Glas (Inboedel)",
  "cover.HOUSECONTENT_JEWELRY": "Lijfsieraden excl. diefstal",
  "cover.HOUSECONTENT_JEWELRY_WITH_THEFT": "Lijfsieraden",
  "cover.HOUSECONTENT_MUSICAL_INSTRUMENTS": "Instrumenten",
  "cover.HOUSECONTENT_VALUABLES": "Kostbaarheden",
  "cover.HOUSECONTENT_INVENTORY": "Inventaris",
  "cover.HOUSECONTENT_AUDIO": "Audiovisuele apparatuur",
  "cover.HOUSECONTENT_OUTSIDE": "Kostbaarheden buitenhuis",
  "cover.HOUSECONTENT_COLLECTABLES": "Verzamelingen",
  "cover.HOUSECONTENT_ART": "Kunst",
  "cover.HOUSECONTENT_TENANT_INTEREST": "Huurdersbelang",
  "cover.HOUSECONTENT_OTHER": "Bijzondere bezittingen",
  "cover.HOUSECONTENT_ELECTRONICS": "Electronica",
  "cover.HOUSECONTENT_RENTAL": "Verhuur",
  "cover.HOUSECONTENT_SPORTS_EQUIPMENT": "Sportuitrusting",
  "cover.HOUSECONTENT_MOBILE_DEVICES": "Mobiele telefoons/apparaten",
  "cover.HOUSECONTENT_MOBILE_DEVICES_WITH_THEFT": "Diefstal Mobiele telefoons/apparaten",
  "cover.HOUSECONTENT_ANTIQUE": "Antique",
  "cover.HOUSECONTENT_OWNER_INTEREST": "Eigenaarsbelang",
  "cover.HOUSECONTENT_CYBER_SECURITY": "Cybersecurity",
  "cover.HOUSECONTENT_SPECIAL": "Bijzondere bezittingen",
  "cover.short.HOUSECONTENT_BASIC": "UGV+",
  "cover.short.HOUSECONTENT_TOP": "AVBKO",
  "cover.short.HOUSECONTENT_GLASS": "Glas",
  "cover.short.HOUSECONTENT_JEWELRY": "Sier z dief",
  "cover.short.HOUSECONTENT_JEWELRY_WITH_THEFT": "Sieraden",
  "cover.short.HOUSECONTENT_MUSICAL_INSTRUMENTS": "Muziek",
  "cover.short.HOUSECONTENT_VALUABLES": "Kostbaarh",
  "cover.short.HOUSECONTENT_INVENTORY": "Invent",
  "cover.short.HOUSECONTENT_AUDIO": "Audio",
  "cover.short.HOUSECONTENT_OUTSIDE": "Buitensh",
  "cover.short.HOUSECONTENT_COLLECTABLES": "Verzamel",
  "cover.short.HOUSECONTENT_ART": "Kunst",
  "cover.short.HOUSECONTENT_TENANT_INTEREST": "Huurdersb",
  "cover.short.HOUSECONTENT_OTHER": "Bijz bezit",
  "cover.short.HOUSECONTENT_ELECTRONICS": "Electro",
  "cover.short.HOUSECONTENT_RENTAL": "Verhuur",
  "cover.short.HOUSECONTENT_SPORTS_EQUIPMENT": "Sportuit",
  "cover.short.HOUSECONTENT_MOBILE_DEVICES": "Mobiel",
  "cover.short.HOUSECONTENT_MOBILE_DEVICES_WITH_THEFT": "Diefst mob ",
  "cover.short.HOUSECONTENT_ANTIQUE": "Antique",
  "cover.short.HOUSECONTENT_OWNER_INTEREST": "Eigenaarsbelang",
  "cover.short.HOUSECONTENT_CYBER_SECURITY": "Cyber",
  "cover.short.HOUSECONTENT_SPECIAL": "Bijz bezit",
  "ownrisk.HOUSECONTENT_GENERIC": "ER Inboedel",
  "ownrisk.HOUSECONTENT_ADDITIONAL": "ER additioneel",
  "insuredamount.HOUSECONTENT_GENERIC": "VS inboedel",
  "insuredamount.HOUSECONTENT_ANTIQUE": "VS antique",
  "insuredamount.HOUSECONTENT_ART": "VS kunst",
  "insuredamount.HOUSECONTENT_AUDIO": "VS audio",
  "insuredamount.HOUSECONTENT_COLLECTABLES": "VS verzamelingen",
  "insuredamount.HOUSECONTENT_ELECTRONICS": "VS electronica",
  "insuredamount.HOUSECONTENT_INVENTORY": "VS inventaris",
  "insuredamount.HOUSECONTENT_JEWELRY": "VS lijfsieraden",
  "insuredamount.HOUSECONTENT_MOBILE_DEVICES": "VS mobiele apparaten (excl diefstal)",
  "insuredamount.HOUSECONTENT_MOBILE_DEVICES_WITH_THEFT": "VS mobiele apparaten (incl diefstal)",
  "insuredamount.HOUSECONTENT_MUSICAL_INSTRUMENTS": "VS instrumenten",
  "insuredamount.HOUSECONTENT_OUTSIDE": "VS buitenshuis",
  "insuredamount.HOUSECONTENT_OUTSIDE_JEWELRY": "VS lijfsieraden buitenshuis",
  "insuredamount.HOUSECONTENT_OWNER_INTEREST": "VS eigenaarsbelang",
  "insuredamount.HOUSECONTENT_RENTAL": "VS verhuur",
  "insuredamount.HOUSECONTENT_SPECIAL": "VS speciaal",
  "insuredamount.HOUSECONTENT_SPORTS_EQUIPMENT": "VS sport apparaten",
  "insuredamount.HOUSECONTENT_TENANT_INTEREST": "VS huurders-/eigenaarsbelang",
  "insuredamount.HOUSECONTENT_VALUABLES": "VS kostbaarheden",
  "cover.HOUSEFIRE_TOP": "AVBKO (Opstal)",
  "cover.HOUSEFIRE_BASIC": "UGV+ (Opstal)",
  "cover.HOUSEFIRE_GLASS": "Glas (Opstal)",
  "cover.HOUSEFIRE_RENTAL": "Verhuur",
  "cover.HOUSEFIRE_GARDEN": "Tuin",
  "cover.short.HOUSEFIRE_TOP": "AVBKO",
  "cover.short.HOUSEFIRE_BASIC": "UGV+",
  "cover.short.HOUSEFIRE_GLASS": "Glas",
  "cover.short.HOUSEFIRE_RENTAL": "Verhuur",
  "cover.short.HOUSEFIRE_GARDEN": "Tuin",
  "ownrisk.HOUSEFIRE_GENERIC": "ER opstal",
  "ownrisk.HOUSEFIRE_ADDITIONAL": "ER additioneel",
  "insuredamount.HOUSEFIRE_GENERIC": "VS opstal",
  "insuredamount.HOUSEFIRE_GARDEN": "VS tuin",
  "insuredamount.HOUSEFIRE_GLASS": "VS glas",
  "cover.TRAVEL_MAIN": "Hoofddekking",
  "cover.TRAVEL_GENERIC": "Hoofddekking",
  "cover.TRAVEL_CANCELLATION": "Annuleringsdekking",
  "cover.TRAVEL_LUGGAGE": "Bagagedekking",
  "cover.TRAVEL_AGENT": "Waarnemersdekking",
  "cover.TRAVEL_MONEY": "Gelddekking",
  "cover.TRAVEL_ACCIDENT": "Ongevallendekking",
  "cover.TRAVEL_ROADSIDE_ASSISTANCE": "Pechhulpverleningsdekking",
  "cover.TRAVEL_REDRESS": "Verhaaldekking",
  "cover.TRAVEL_SPORTS": "Bijzondere sportdekking",
  "cover.TRAVEL_COMPOSED_JOURNEY": "Samengestelde reisdekking",
  "cover.TRAVEL_SPORTGEAR": "Sportuitrustingsdekking",
  "cover.TRAVEL_SKIING": "Skivakantiedekking",
  "cover.TRAVEL_MEDICAL_EXPENSES": "Medische kostendekking",
  "cover.short.TRAVEL_MAIN": "Basis",
  "cover.short.TRAVEL_GENERIC": "Basis",
  "cover.short.TRAVEL_CANCELLATION": "Annulering",
  "cover.short.TRAVEL_LUGGAGE": "Bagage",
  "cover.short.TRAVEL_AGENT": "Waarnemer",
  "cover.short.TRAVEL_MONEY": "Geld",
  "cover.short.TRAVEL_ACCIDENT": "Ongeval",
  "cover.short.TRAVEL_ROADSIDE_ASSISTANCE": "Pechhulp",
  "cover.short.TRAVEL_REDRESS": "Verhaal",
  "cover.short.TRAVEL_SPORTS": "Bijz. Sport",
  "cover.short.TRAVEL_COMPOSED_JOURNEY": "Samengest.",
  "cover.short.TRAVEL_SPORTGEAR": "Sportuitr.",
  "cover.short.TRAVEL_SKIING": "Skivak.",
  "cover.short.TRAVEL_MEDICAL_EXPENSES": "Medisch",
  "ownrisk.TRAVEL_MAIN": "Algemeen eigen risico",
  "ownrisk.TRAVEL_GENERIC": "ER standaard",
  "ownrisk.TRAVEL_SPORTGEAR": "ER sportuitrusting",
  "ownrisk.TRAVEL_LUGGAGE": "ER bagage",
  "insuredamount.TRAVEL_CANCELLATION": "VS annuleringsdekking",
  "insuredamount.TRAVEL_LUGGAGE": "VS bagage",
  "combiCover.HOUSECONTENT_TOP": "AVBKO (Inboedel)",
  "combiCover.HOUSECONTENT_BASIC": "UGV+ (Inboedel)",
  "combiCover.HOUSEFIRE_TOP": "AVBKO (Opstal)",
  "combiCover.HOUSEFIRE_BASIC": "UGV+ (Opstal)",
  "combiCover.HOUSECONTENT_GLASS": "Glas (Inboedel)",
  "combiCover.HOUSEFIRE_GLASS": "Glas (Opstal)",
  "combiOwnrisk.HOUSECONTENT_GENERIC": "ER inboedel",
  "combiOwnrisk.HOUSEFIRE_GENERIC": "ER opstal",
  "combiInsuredamount.HOUSECONTENT_GENERIC": "VS inboedel",
  "combiInsuredamount.HOUSEFIRE_GENERIC": "VS opstal",
  "auto.depreciationScheme": "Afschrijvingsregeling",
  "auto.depreciationScheme.STANDARD": "Standaard",
  "auto.depreciationScheme.PURCHASED_VALUE": "Aanschafwaarde",
  "auto.depreciationScheme.CURRENT_NEW_VALUE": "Nieuwwaarde",
  "travel.maxTravelDuration": "Maximale Reistijd",
  "auto.depreciationScheme.standard": "Standaard",
  "auto.depreciationScheme.purchasedValue": "Aanschafwaarde",
  "auto.depreciationScheme.currentNewValue": "Nieuwwaarde",
  "msg.ERROR_LOADING_SUMMARY": "Er is een fout opgetreden bij het ophalen van samenvatting.",
  "msg.ERROR_LOADING_DETAILS": "Er is een fout opgetreden bij het ophalen van details.",
  "msg.ERROR_DURING_OPERATION": "Er is een fout opgetreden bij de bewerking.",
  "msg.ERROR_DUPLICATE_RECORD": "A record with the same identifier already exists. Please use a unique identifier.;",
  "msg.ERROR_DUPLICATE_RECORD_STEP": "Het is niet toegestaan om meerdere dezelfde treden in te voeren.",
  "msg.ERROR_DUPLICATE_RECORD_LINE": "Het is niet toegestaan om meerdere dezelfde regels in te voeren.",
  "PRODUCT_LINE": "Branche",
  "DOWNLOAD_TEMPLATE": "Sjabloon ophalen",
  "UPLOAD_FILE": "Bestand uploaden",
  "SUBMIT": "Versturen",
  "NAME": "Naam",
  "FIRST_NAME": "Voornaam",
  "LAST_NAME": "Achternaam en toevoeging",
  "USERNAME": "Gebruikersnaam",
  "EMAIL": "E-mail",
  "ROLES": "Rollen",
  "EDIT": "Wijzigen",
  "TYPE": "Type",
  "COMPLETED": "Gereed",
  "ERRORS": "Fouten",
  "WARNINGS": "Waarschuwingen",
  "REPORT": "Rapport",
  "DELETE": "Verwijderen",
  "CLOSE": "Sluiten",
  "DOWNLOAD": "Ophalen",
  "TOTAL_ROWS": "Totaal aantal",
  "CASE": "Case",
  "MESSAGE": "Bericht",
  "BATCH_ID": "Batch naam",
  "POLICY_CASE_STATUS": "Case status",
  "EXECUTE": "Uitvoeren",
  "COUNT": "Aantal",
  "BATCH": "Batch",
  "BATCHES": "Batches",
  "ITEMS": "Items",
  "DISABLED": "Niet beschikbaar",
  "ALL": "Alles",
  "CREATION_DATE": "Aanmaakdatum",
  "msg.CANT_UPLOAD_FILE": "Kan bestand niet uploaden.",
  "DUPLICATE_CODE": "Deze code wordt al gebruikt.",
  "CASE_IMPORT": "Importeer Case",
  "IMPORT_CONSISTS_LINE": "Import bestaat uit een regel per",
  "POLICY": "Polis",
  "CUSTOMER_IMPORT": "Klantimport",
  "UPLOAD_CASE_LIST": "Lijst met importregels uploaden",
  "UPLOAD_CUSTOMER_LIST": "Lijst met klanten uploaden",
  "ACTIVE_IMPORT_JOBS": "Actieve import taken",
  "JOB": "Taak",
  "PAUSE": "Gepauzeerd",
  "START": "Starten",
  "CANCEL": "Annuleren",
  "LINE_NR": "Lijn nr.",
  "JOBS": "Taken",
  "STARTDATE": "Startdatum",
  "JOB_TYPE": "Taak type",
  "SEE_HISTORY_OVERVIEW": "Naar geschiedenisoverzicht",
  "SEE_HISTORY": "Historie tonen",
  "HISTORY_OVERVIEW": "Geschiedenisoverzicht",
  "USER_LAST_MODIFIED": "Gebruiker als laatste gewijzigd",
  "DATE_LAST_MODIFIED": "Datum laatst gewijzigd",
  "VERSION": "Versie",
  "SERVER_ERROR": "Serverfout",
  "msg.LIST_HISTORY_OVERVIEW_EMPTY": "Er zijn geen historiecases gevonden.",
  "msg.ERROR_GETTING_JOB_DETAILS": "Er is een fout opgetreden bij het ophalen van taakdetails.",
  "msg.ERROR_STARTING_JOB": "Er is een fout opgetreden bij het starten van de taak.",
  "msg.ERROR_PAUSING_JOB": "Er is een fout opgetreden bij het pauzeren van de taak.",
  "msg.ERROR_CANCELING_JOB": "Er is een fout opgetreden bij het annuleren van de taak.",
  "msg.SURE_CANCEL_ACTION": "Weet u zeker dat u deze taak wilt annuleren?",
  "job.COMPLETE": "Gereed",
  "job.RUNNING": "Bezig",
  "job.PAUSE_IN_PROGRESS": "Pauzeren",
  "job.PAUSED": "Gepauzeerd",
  "job.VALIDATED": "Gevalideerd",
  "job.PENDING": "In de wachtrij",
  "job.CANCELED": "Geannuleerd",
  "job.EXPIRED": "Verlopen",
  "job.FAILED": "Fout",
  "job.VALIDATION_FAILED": "Validatie fout",
  "action.RUNNING": "Uitvoeren",
  "SELECT_ALL_FIELDS": "Selecteer alle verplichte velden.",
  "CLOSE_EXPORTED_CASES": "Sluit ook geëxporteerde cases.",
  "TRANSFORMATION_OUTPUT_FILE": "Export bestand",
  "msg.SURE_DELETE_FILE": "Weet u zeker dat u dit bestand wilt verwijderen?",
  "BATCH_MANAGEMENT": "Batchbeheer",
  "POLICYCASE_BATCH_MANAGEMENT": "Case Batchbeheer",
  "CUSTOMER_BATCH_MANAGEMENT": "Klant Batchbeheer",
  "SEARCH_BATCHES": "Zoeken op batch naam",
  "SEE_ACTIONS_OVERVIEW": "Naar actieoverzicht",
  "CANCEL_QUEUED_ACTIONS": "Annuleren van acties in de wachtrij",
  "GO_TO_JOB": "Ga naar de taak",
  "RECALCULATING": "Herberekenen...",
  "PENDING_RECALCULATION": "Herberekenen in de wachtij...",
  "CLOSING": "Sluiten...",
  "PENDING_CLOSE": "Sluiten in de wachtrij...",
  "DELETING": "Verwijderen...",
  "PENDING_DELETE": "Verwijderen in de wachtrij...",
  "msg.FOLLOWING_STATUSES_CANNOT_RECALCULATE": "De volgende statussen kunnen niet worden herberekend: Beëindigd, Historie.",
  "msg.FOLLOWING_STATUSES_CANNOT_CLOSE": "De volgende statussen kunnen niet worden gesloten: Beëindigd, Historie, Heropend.",
  "msg.SURE_DELETE_BATCHES": "Weet u zeker dat u deze batch wilt verwijderen?",
  "msg.UNRECOGNISED_BATCH_ACTION": "Onbekende batch actie",
  "msg.RECALC_ACTION_ADDED_QUEUE": "Een 'Herberekenen' actie is toegevoegd aan de wachtrij.",
  "msg.CLOSE_ACTION_ADDED_QUEUE": "Een 'Sluiten' actie is toegevoegd aan de wachtrij.",
  "msg.DELETE_ACTION_ADDED_QUEUE": "Een 'Verwijderen' actie is toegevoegd aan de wachtrij.",
  "msg.DELETE_CUSTOMERS_ACTION_ADDED_QUEUE": "Een 'Klant Verwijderen' actie is toegevoegd aan de wachtrij.",
  "msg.RECALC_ACTION_NOT_ADDED_QUEUE": "Toevoegen van 'Herberekenen' aan de wachtrij niet mogelijk.",
  "msg.CLOSE_ACTION_NOT_ADDED_QUEUE": "Toevoegen van 'Sluiten' aan de wachtrij niet mogelijk.",
  "msg.DELETE_ACTION_NOT_ADDED_QUEUE": "Toevoegen van 'Verwijderen' aan de wachtrij niet mogelijk.",
  "msg.DELETE_CUSTOMERS_ACTION__NOT_ADDED_QUEUE": "Toevoegen van 'Klant Verwijderen' aan de wachtrij niet mogelijk.",
  "msg.SOMETHING_WRONG_FETCH_ACTIONS": "Er is iets misgegaan met het ophalen van de lijst met acties.",
  "msg.SURE_CANCEL_PENDING_ACTIONS": "Weet u zeker dat u alle acties die in de wachtrij staan wilt annuleren?",
  "msg.NETWORK_ERROR_BIG_FILE_IMPORT": "Netwerkfout. Gebruik een bestandsgrootte van minder dan 10 MB.",
  "NO_BATCHES_FOUND": "Geen batches gevonden.",
  "UPLOAD_CASE_IDS_LIST": "Lijst met polisnummers uploaden",
  "ACTIONS_OVERVIEW": "Actieoverzicht",
  "DATE_OF_ACTION": "Actiedatum",
  "STATUSES_PER_PRODUCT_LINE": "Status per branche",
  "AUTHOR": "Eigenaar",
  "ACTION": "Actie",
  "DOWNLOAD_CASE": "PDF bestand ophalen",
  "ACCEPTED_MANUALLY": "Handmatig accepteren",
  "SAVE_CASE": "Casus opslaan",
  "DOWNLOAD_FILE": "Bestand ophalen",
  "DELETE_FILE": "Bestand verwijderen",
  "msg.LIST_ACTIONS_EMPTY": "Geen acties gevonden.",
  "msg.MISSING_EXPORT_FILE": "Bestand is niet meer beschikbaar.",
  "CLOSE_MULTIPLE_CASES": "Meerdere cases sluiten.",
  "FILE_CONTAINING_CASES": "\"Bestand met case id's.\"",
  "CLOSE_ALL": "Sluit alles",
  "msg.FOLLOWING_CASES_SKIPPED": "De volgende cases zijn overgeslagen:",
  "msg.CASES_CLOSED_SUCCESS": "De cases zijn succesvol gesloten.",
  "UPLOAD_CONFIGURATION_FILE": "Scherminrichtingsbestand uploaden",
  "OR_EDIT_DIRECTLY": "Of wijzig het hier:",
  "LOAD_DEFAULT": "Standaard waarden laden",
  "STORE_CURRENT_AS_DEFAULT": "Huidige waarden als standaard",
  "GENERATE_TEMPLATE": "Generate import template",
  "SAVE_CHANGES": "Wijzigingen opslaan",
  "msg.FIX_EDITOR_ERRORS": "Los eerst de fouten op.",
  "msg.CONFIGURATION_SAVED": "Scherminrichting succesvol opgeslagen.",
  "msg.ERROR_SAVING_CONFIGURATION": "Er is een fout opgetreden bij het opslaan van de scherminrichting.",
  "msg.LOADED_DEFAULT_CONFIGURATION": "Standaardwaarden geladen.",
  "msg.ERROR_LOADING_DEFAULT_CONFIGURATION": "Er is een fout opgetreden bij het laden van de standaardconfiguratie.",
  "msg.CURRENT_CONFIGURATIONS_SAVED_AS_DEFAULT": "Deze configuratie is opgeslagen als standaardconfiguratie.",
  "msg.ERROR_STORING_CURRENT_CONFIGURATIONS_AS_DEFAULT": "De nieuwe standaardconfiguratie kon helaas niet opgeslagen worden, neem contact op met de beheerder.",
  "POLICYCASE_FORM_CONFIGURATION": "Caseformulier configuratie",
  "CUSTOMER_FORM_CONFIGURATION": "Klant Configuratiebeheer",
  "msg.SURE_OVERWRITE_CONFIGURATION_UPLOAD": "Weet u zeker dat u de huidige configuratie overschrijft?",
  "msg.SURE_OVERWRITE_CURRENT_CONFIGURATION": "Hiermee overschrijft u de huidige configuratie. Weet u het zeker?",
  "msg.SURE_OVERWRITE_DEFAULT_CONFIGURATION": "Hiermee overschrijft u de standaardconfiguratie voor dit forumulier. Weet u het zeker?",
  "msg.ERROR_STORING_GENERATE_IMPORT_TEMPLATE": "The generation of import template failed , please contact the administrator.",
  "CUSTOMER_MANAGEMENT": "Klantenbeheer",
  "SEARCH_BY_NAME_OR_UNIQUE_ID": "Relatie # of Naam",
  "SEARCH_BY_NAME_USERNAME_EMAIL": "Zoeken op naam, gebruikersnaam of e-mailadres",
  "CRM_LINK": "CRM link",
  "msg.NO_CUSTOMERS_FOUND": "Geen klanten gevonden.",
  "msg.FOLLOWING_WARNINGS_OCCURRED": "De volgende waarschuwing is opgetreden:",
  "msg.CUSTOMERS_UPLOAD_SUCCESS": "De lijst met klanten is succesvol geuploaded.",
  "ENABLE_PRODUCT_LINE": "Branche beschikbaar maken",
  "DISABLE_PRODUCT_LINE": "Branche onbeschikbaar maken",
  "UPLOAD_TRANSFORMATION_FILE": "Transformatiebestand uploaden",
  "msg.TRANSFORMATION_FILE_UPLOAD_SUCCESS": "Transformatiebestanden zijn succesvol opgeslagen.",
  "msg.MISSING_TRANSFORMATION_FILE": "Ontbrekend transformatiebestand voor branche:",
  "UPLOAD_PDF_TEMPLATE_FILE": "Upload PDF sjabloonbestand",
  "msg.PDF_TEMPLATE_FILE_UPLOAD_SUCCESS": "PDF sjabloonbestanden zijn succesvol opgeslagen.",
  "msg.MISSING_PDF_TEMPLATE_FILE": "Onvolledig PDF sjabloonbestand voor product:",
  "USER_MANAGEMENT": "Gebruikersbeheer",
  "ADD_NEW_USER": "Nieuwe gebruiker toevoegen",
  "CREATE_USER": "Gebruiker aanmaken",
  "EDIT_USER": "Gebruiker wijzigen",
  "NO_USERS_FOUND": "Geen gebruikers gevonden.",
  "ADD_USER": "Gebruiker toevoegen",
  "EDIT_ROLES_USER": "Wijzig rollen voor gebruiker",
  "AVAILABLE_ROLES": "Beschikbare rollen",
  "GRANTED_ROLES": "Toegewezen rollen",
  "msg.SURE_DELETE_USER": "Weet u zeker dat u deze gebruiker wilt verwijderen?",
  "msg.UNABLE_LOAD_USER_ROLES": "Niet mogelijk om de gebruikersrollen op te halen.",
  "msg.ROLE_GRANTED": "Rol is toegewezen aan gebruiker:",
  "msg.ROLE_REMOVED": "Rol is verwijderd voor gebruiker:",
  "msg.ADDING_NEW_USER": "Nieuwe gebruiker toevoegen:",
  "msg.USER_CREATED": "Gebruiker is aangemaakt.",
  "msg.EDIT_USER": "Wijzigen gebruiker:",
  "msg.USER_CHANGES_SAVED": "Wijzigingen voor de gebruiker zijn opgeslagen.",
  "msg.DELETE_USER": "Gebruiker verwijderen:",
  "msg.USER_DELETED": "Gebruiker is verwijderd.",
  "msg.INVALID_EMAIL_ADDRESS": "Ongeldig e-mail adres",
  "AUDIT_OVERVIEW": "Audit bericht overzicht",
  "REQUESTED_POLICY": "Aanvraag polis",
  "SEE_MESSAGES": "Zie berichten",
  "FILES": "Bestanden",
  "LAST_MODIFIED": "Laatst gewijzigd",
  "CREATED": "Aangemaakt",
  "ADD_RULE": "Voeg business regel toe",
  "RESET_KIE_CONTAINER": "Business rules verversen",
  "SELECT_FILE": "Selecteer een bestand van de lijst",
  "FILENAME": "Bestandsnaam",
  "ALLOWED_SYMBOLS": "Alleen letters, cijfers en koppeltekens toegestaan.",
  "CHECK_VALIDATION_ERRORS": "Herstel foute invoer.",
  "INPUT_VALIDATION_ERROR": "Verwacht formaat:",
  "SAVE": "Opslaan",
  "SAVING": "Aan het opslaan…",
  "ENABLED": "Beschikbaar",
  "WHEN": "ALS",
  "THEN": "DAN",
  "ADD": "Toevoegen",
  "ADD_CONDITION_IN_RULE": "Toevoegen van een conditie aan de business regel",
  "msg.SURE_UNSAVED_CHANGES_IN_RULE": "Er zijn niet opgeslagen wijzigingen. Weet u zeker dat u verder wilt gaan?",
  "msg.SUCCESSFULLY_REMOVED_FILE": "Bestand is succesvol verwijderd.",
  "msg.REMOVED_SUCCESSFULLY": "succesvol verwijderd.",
  "msg.SAVED_SUCCESSFULLY": "succesvol opgeslagen.",
  "msg.SURE_DROOLS_RESET": "Na het verversen van de business rules zal bij de eerstvolgende import, herbereking of preview de business rules opnieuw worden geladen. Dit kan voor een merkbare vertraging zorgen.",
  "msg.DROOLS_RESET_SUCCESS": "Business rules zijn ververst.",
  "msg.DROOLS_RESET_CREATED": "Bedrijfsregels zijn met succes gemaakt.",
  "RULES_GIT_SETTINGS_TITLE": "Git instellingen",
  "RULES_GIT_URL": "Git URL",
  "RULES_GIT_BRANCH": "Git branch",
  "msg.BRANCH_CHANGE_SUCCESS": "Branch is succesvol gewijzigd.",
  "msg.ERROR_LOADING_GIT_CONFIGURATIONS": "Git-configuraties kunnen niet worden geladen.",
  "SELECT_EXCEL_FILE": "Selecteer Excel-bestand",
  "API_TO_AFD_MAPPING": "API NAAR AFD MAPPING",
  "ADD_API_MAPPING": "API MAPPING TOEVOEGEN",
  "dialog.YES": "Ja",
  "dialog.NO": "Nee",
  "dialog.OK": "OK",
  "ACTIVE": "Actief",
  "error.LOCK_CHANGE_FAILED": "Veranderen van slot is mislukt.",
  "error.FORM_INVALID_PLEASE_FILL": "Formulier kan niet verstuurd worden in verband met ontbrekende verplichte informatie. Controleer het formulier op rood omrande velden.",
  "XSD_DESCRIPTION": "XSD Omschrijving",
  "SUIV_DESCRIPTION": "Omschrijving",
  "SUIV_NAME": "Naam ",
  "SUIV_PRODUCT": "VPI productId",
  "AL_VIEWCOD": "Viewcode",
  "_PPRC": "Provisiepercentage",
  "msg.GENERATE_TEMPLATE_MSG": "Generate import template will replace existing template if exists , are you sure?",
  "commissionAmount": "Provisie",
  "BACKOFFICE_CODE_INCOMING": "Backoffice code (inkomend)",
  "BACKOFFICE_CODE_OUTGOING": "Backoffice code (uitgaand)",
  "AFD_CODE": "afd code",
  "msg.GIM_UPLOAD_SUCCESS": "Gim object file had uploaded successfully",
  "GIM_OBJECT_NAME": "Gim object file name",
  "GIM_OBJECT_DESCRIPTION": "Gim object file",
  "gim_object": "GIM registratiebericht",
  "GIMOBJECTID": "GimObject Id",
  "No_Claims_Discount_DESCRIPTION": "Omschrijving",
  "Step": "Trede",
  "DiscountPercentage": "Kortingspercentage",
  "SUBBRANCHE_DESCRIPTION": "Omschrijving",
  "Verrijking": "Verrijking",
  "VEHICLE_INFORMATION": "Voertuiginformatie",
  "BUILDING_INFORMATION": "Gebouwinformatie",
  "NONE": "Geen",
  "SubBranche": "Subbranche",
  "DUPLICATE_PRODUCTLINE": "Er bestaat al een branche met deze subbranche.",
  "err.productline.not_found": "Branche '{0}' niet gevonden.",
  "err.policynumber.duplicate_found": "Er zijn meerdere identieke polisnummers in het importbestand gevonden: {0}."
}


//////////////////
// WEBPACK FOOTER
// ./src/language.properties
// module id = DBUa
// module chunks = 1